export const PROPERTY_MUTATION_SYNC_FAILURE_MESSAGE =
    'Unable to sync property changes. Please refresh and try again.';

const ERROR_MESSAGES_BY_CODE = {
    unauthenticated: 'Please sign in and try again.',
    'permission-denied': 'You do not have permission to edit this property.',
    'invalid-argument': 'Invalid property data. Please review your changes and try again.',
    'not-found': 'This property no longer exists. Refresh to get the latest data.',
    'failed-precondition': 'Property data is out of date. Refresh and try again.',
};

export function getCallableErrorCode(error) {
    if (!error || typeof error !== 'object') return 'unknown';
    if (typeof error.code === 'string' && error.code.length > 0) {
        return error.code.replace(/^functions\//, '');
    }
    return 'unknown';
}

export function isRetryableConflict(error) {
    return getCallableErrorCode(error) === 'aborted';
}

export function toPropertyMutationUserMessage(error, options = {}) {
    const {retriesExhausted = true} = options;
    const code = getCallableErrorCode(error);

    if (code === 'aborted') {
        return retriesExhausted ? PROPERTY_MUTATION_SYNC_FAILURE_MESSAGE : null;
    }

    return ERROR_MESSAGES_BY_CODE[code] || 'Unable to save property changes right now. Please try again.';
}

export function mapPropertyMutationError(error, options = {}) {
    const code = getCallableErrorCode(error);
    return {
        code,
        retryable: code === 'aborted',
        message: toPropertyMutationUserMessage(error, options),
    };
}

